var React = require('react');

function About (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"fill-none stroke-foreground","d":"M9.6,13.8c1.1,0,2,0.9,2,2s-0.9,2-2,2H6.2c-1.1,0-2,0.9-2,2c0,1.1,0.9,2,2,2h12.1c1.1,0,2-0.9,2-2\n\t\tc0-1.1-0.9-2-2-2h-1c-1.1,0-2-0.9-2-2s0.9-2,2-2l4.1,0c1.1,0,2-0.9,2-2s-0.9-2-2-2h-8c-1.1,0-2-0.9-2-2s0.9-2,2-2h1.5\n\t\tc1.1,0,2-0.9,2-2s-0.9-2-2-2H3.1c-1.1,0-2,0.9-2,2s0.9,2,2,2h2.5c1.1,0,2,0.9,2,2s-0.9,2-2,2H2.6c-1.1,0-2,0.9-2,2s0.9,2,2,2\n\t\tL9.6,13.8z"}));
}

About.defaultProps = {"version":"1.1","width":"24px","height":"24px","viewBox":"0 0 24 24","style":{"enableBackground":"new 0 0 24 24"},"xmlSpace":"preserve"};

module.exports = About;

About.default = About;
